import { Link } from 'react-router-dom';
import { categories, categoryColorMap } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <p className="text-foreground-400 text-sm tracking-wide mb-2">热门分类</p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold">
            吃瓜分类入口
          </h2>
          <p className="font-heading text-xl md:text-2xl text-foreground-950/80 mt-1">
            你想吃的瓜，这里都有
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = categoryColorMap[cat.color];
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="bg-background-50 rounded-lg p-6 md:p-7 hover:bg-background-100 transition-all duration-300 cursor-pointer group"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${colors.badge} ${colors.badgeText} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 font-bold mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}